import { IconButton } from '@mui/material';
import moment from 'moment';
import { FaEye } from 'react-icons/fa';

export const Acciones = ({ acciones = [], setOpenHistoricoAccion }) => {
  return acciones.map((item, index) => (
    <div className="mt-2 pt-3 pb-2 mb-2 border" key={index}>
      <div className="row ">
        <div className="col-md-1 text-center align-self-center">
          <h1 className="text-primary-mem">{index + 1}</h1>
        </div>

        <div className="col-md-3 ">
          <div className="col-md-12 text-center">
            <label className="fw-bold">Categoría</label>
          </div>
          <div className="col-md-12 text-center">
            <label className="">{item.categoriaAccion}</label>
          </div>
        </div>

        <div className="col-md-3 ">
          <div className="col-md-12 text-center">
            <label className="fw-bold">Tipo</label>
          </div>
          <div className="col-md-12 text-center">
            <label className="">{item.tipoAccion}</label>
          </div>
        </div>

        <div className="col-md-2 ">
          <div className="col-md-12 text-center">
            <label className="fw-bold">Estado</label>
          </div>
          <div className="col-md-12 text-center">
            <label className="">{item.estado}</label>
          </div>
        </div>

        <div className={(!Array.isArray(item.historico) || item.historico.length === 0) ? 'col-md-2' : 'col-md-1'}>
          <div className="col-md-12 text-center">
            <label className="fw-bold">Fecha Creción</label>
          </div>
          <div className="col-md-12 text-center">
            <label>{moment(item.fechaCreacion).format('DD/MM/yyyy')}</label>
          </div>
        </div>

        <div className="col-md-1" hidden={(!Array.isArray(item.historico) || item.historico.length === 0)}>
          <div className="d-flex justify-content-end">
            <IconButton
              onClick={() =>
                setOpenHistoricoAccion({
                  open: true,
                  historico: Array.isArray(item.historico) ? item.historico.filter(Boolean) : [],
                  reclutamiento: String(item.categoriaAccion ?? '').toLowerCase() === 'reclutamiento',
                })
              }
              className="mt-2"
            >
              <FaEye color="#003876" />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  ));
};
